import React from 'react';
import T from 'prop-types';

const privacyUrl = '/en/privacy';

const PageLayout = ({ children }) => (
  <div className="press-register-page">
    <header className="press-register-page__header">
      <a
        className="press-register-page__logo"
        data-label="Apptopia Logo"
        href="https://apptopia.com/"
      >
        <span className="hidden">Apptopia Logo</span>
      </a>
    </header>
    <div className="press-register-page__content">{children}</div>
    <footer className="press-register-page__footer">
      <span>© {new Date().getFullYear()} Apptopia, Inc.</span>
      <a href={privacyUrl}>Privacy Policy</a>
    </footer>
  </div>
);

PageLayout.propTypes = {
  children: T.node.isRequired,
};

export default PageLayout;
